export default {
  main: '#A7C6D8',
  secondary: '#67b987',
  contrastingColor: '#000000',
  priceColor: '#E1235F',
  entryBackground: '#A7C6D8',
  menuBackgroundColor: '#A7C6D8',
  menuTextColor: '#000000',
};
